import ABCyaPhaser from '@abcya/abcya_phaser'
import TextUtils from '@abcya/abcya_phaser/src/js/Utils/GameObjects/UI/TextUtils';
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class Key extends Phaser.GameObjects.Container
{
    constructor(scene, pCont, keyId, w, h)
    {
        super(scene);
        pCont.add(this);

        this.scene = scene;
        this.pCont = pCont;
        this.keyWidth = w;
        this.keyHeight = h;
        this.keyValue = keyId;
        this.fontSize = 30;

        if(this.keyValue.indexOf("shift") != -1) this.keyValue = "shift";
        if(this.keyValue == "shift" || this.keyValue == "enter" || this.keyValue == "delete"){
            this.keyWidth = w * 2;
        }else if(this.keyValue == "space"){
            this.keyWidth = w * 5;
        }
        this.keyId = keyId + "_key";

        this.keyStr = this.keyValue;

        this.setSize(this.keyWidth, this.keyHeight);
        

        this.createKey();
    }

    createKey()
    {
        this.keyText = ABCyaPhaser.Text.addText(0, 0, this.fontSize, "0x333", gameData.GAME_FONTS[0], this.keyStr, this);
        this.keyText.setPosition(this.keyWidth/2, this.keyHeight/2 + (this.keyText.height/4));
    }

    upperCase() {
        if(this.keyValue == "shift" || this.keyValue == "enter" || this.keyValue == "delete") return;
        this.keyText.destroy();

        this.keyValue = this.keyValue.toUpperCase();
        const keyStr =  this.keyValue;
        
        this.keyText = ABCyaPhaser.Text.addText(0, 0, this.fontSize, "0x333", FontKeys._curse_casualregular, keyStr, this);
        this.keyText.setPosition(this.keyWidth/2, this.keyHeight/2 + (this.keyText.height/4));

    };

    lowerCase() {
        if(this.keyValue == "shift" || this.keyValue == "enter" || this.keyValue == "delete") return;

        this.removeChild(this.keyText);

        this.keyValue = this.keyValue.toLowerCase();
        const keyStr =  this.keyValue;

        this.keyText = ABCyaPhaser.Text.addText(0, 0, this.fontSize, "0x333", FontKeys._curse_casualregular, keyStr, this);
        this.keyText.setPosition(this.keyWidth/2, this.keyHeight/2 + (this.keyText.height/4));
    };

    setKeyColors(color1,color2){
        this.upColor = color1;
        this.downColor = color2;
        
        this.showKeyPress(false);
    };

    showKeyPress(isDown){
        this.isDown = isDown;
        
        const newColor = (this.isDown == true) ? this.downColor : this.upColor;

        if(this.keyShape) this.keyShape.destroy();
        this.keyShape = ABCyaPhaser.Graphics.addRoundedRect(this.keyWidth/2, this.keyHeight/2, this.keyWidth, this.keyHeight, 6, newColor, this, null, true, true);

        this.moveBelow(this.keyShape, this.keyText);
    };

    disableKey()
    {
        this.keyShape.disableInteractive();
    }
}